export default "__VITE_ASSET__hFpt$_Gd__"